<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ii"><strong>Praise for Jenn Bennett and <em>Kindling the Moon</em></strong></a></p><a id="page_ii">
<p class="blockquote">“Jenn Bennett has written a great off-beat debut novel with a likeable heroine and a fun, original storyline. … I thoroughly enjoyed it and am eagerly awaiting a sequel—hopefully to come out soon!”</p>
<p class="att">—Karen Chance, <em>New York Times</em> bestselling author of <em>Death’s Mistress</em></p>
<p class="blockquote">“<em>Kindling the Moon</em> engaged me from page one. I loved it! I immediately adored the heroine, Arcadia Bell. This book is packed from cover to cover with unpredictable twists, heart-pounding action, and heated sexual tension. … Jenn Bennett has definitely made my ‘To Buy’ list, and I’m looking forward to the next book in this series.”</p>
<p class="att">—Anya Bast, <em>New York Times</em> bestselling author of <em>Cruel Enchantment</em></p>
<p class="blockquote">“<em>Kindling the Moon</em> rocks like AC/DC on Saturday night. This book has it all: great writing, action, romance, a strong heroine, a unique hero, and the best teenager ever. I can’t wait for the next one.”</p>
<p class="att">—Ann Aguirre, national bestselling author of <em>Shady Lady</em></p>
<p class="blockquote">“Debut author Jenn Bennett takes the familiar ideas of magic, demons, and mythology, and she gives us something sexy, fun, and genuinely unique in <em>Kindling the Moon</em>. Arcadia Bell is a sassy, whip-smart addition to the growing pantheon of urban fantasy heroines, and Bennett an author to watch!”</p>
<p class="att">—Kelly Meding, author of <em>Three Days to Dead</em></p>
</a><p class="blockquote"><a id="page_ii"></a><a id="page_iii">“Fantastic magic, nonstop action, and hot romance make <em>Kindling the Moon</em> a not-to-be-missed debut. Arcadia Bell is a tenacious and savvy heroine who had me hooked from the start.”</a></p><a id="page_iii">
<p class="att">—Linda Robertson, author of <em>Arcane Circle</em></p>
<p class="blockquote">“Delicious characters, fun twists, and fiendish risks. … This smart, stylish debut really delivers. Loved, loved, loved it!”</p>
<p class="att">—Carolyn Crane, author of <em>Double Cross</em></p>
</a><p class="center"><a id="page_iii"><strong>This title is also available as an eBook</strong></a><a id="page_iv"></a></p><a id="page_iv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?3e0e35c8